import moment from 'moment';

import { shouldMachineBeRestocked } from './shouldMachineBeRestocked';

export const getServiceRunPicklistCalculatedTime = serviceDockets => {
	const time = serviceDockets.reduce((acc, docket) => {
		if (!shouldMachineBeRestocked(docket.machineServiceType) || !docket.pickList || !docket.pickList.calculatedAt) {
			return acc;
		}

		if (!acc || docket.pickList.calculatedAt > acc) {
			return docket.pickList.calculatedAt;
		}

		return acc;
	}, null);

	return time ? moment(time) : null;
};
